import { render, staticRenderFns } from "./Codeofethics.vue?vue&type=template&id=4e02a948&scoped=true&"
import script from "./Codeofethics.vue?vue&type=script&lang=js&"
export * from "./Codeofethics.vue?vue&type=script&lang=js&"
import style0 from "./Codeofethics.vue?vue&type=style&index=0&id=4e02a948&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e02a948",
  null
  
)

/* custom blocks */
import block0 from "./Codeofethics.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports